module.exports = __webpack_public_path__ + "static/media/hero.1c9e2611.png";